export const EVALUACION_TALLER_DEFAULT = {
  diagnostico: 0,
  reparacion_efectiva: 0,
  puntualidad: 0,
  comunicacion: 0,
  trabajos_completados: 0,
  facturacion_rapida: 0,
  garantia: 0,
  comentarios: "",
} as const;

export type EvaluacionTallerState = {
  diagnostico: number;
  reparacion_efectiva: number;
  puntualidad: number;
  comunicacion: number;
  trabajos_completados: number;
  facturacion_rapida: number;
  garantia: number;
  comentarios: string;
};

const EVALUACION_CAMPOS: (keyof Omit<EvaluacionTallerState, "comentarios">)[] = [
  "diagnostico",
  "reparacion_efectiva",
  "puntualidad",
  "comunicacion",
  "trabajos_completados",
  "facturacion_rapida",
  "garantia",
];

export function normalizeEvaluacionTaller(
  raw?: Record<string, unknown> | null,
): EvaluacionTallerState {
  if (!raw) {
    return { ...EVALUACION_TALLER_DEFAULT };
  }

  return {
    diagnostico: Number(raw.diagnostico) || 0,
    reparacion_efectiva: Number(raw.reparacion_efectiva) || 0,
    puntualidad: Number(raw.puntualidad) || 0,
    comunicacion: Number(raw.comunicacion) || 0,
    trabajos_completados: Number(raw.trabajos_completados) || 0,
    facturacion_rapida: Number(raw.facturacion_rapida) || 0,
    garantia: Number(raw.garantia) || 0,
    comentarios: String(raw.comentarios ?? ""),
  };
}

export function isEvaluacionTallerCompleta(
  evaluacion: EvaluacionTallerState,
): boolean {
  return EVALUACION_CAMPOS.every((campo) => Number(evaluacion[campo]) >= 1);
}
